import { Link } from "react-router-dom"
import styled from "styled-components";
import { theme } from '../../../../theme'
import {
    MdAssessment
} from "react-icons/md";
import { Button } from '../../../../components/button'


const Item = styled.div`
    display: flex;
    align-items: center;
    padding: 1.1rem;
    border-bottom: 1px solid rgb(216 216 216 / 37%);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    justify-content: space-between;
    background-color: ${theme.colors.mainWhite};
`

const ImageTextContainer = styled.div`
    display: flex;
    align-items: center;
`

const ImageContainer = styled.div`
    width: 3.5rem;
    height: 3.5rem;
    color: ${theme.colors.mainBlue};
    background: rgba(33, 150, 243, 0.44);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        height: 2.4rem;
        width: 2.4rem;
    }
`


const TextContainer = styled.div`
    margin-left: 1.3rem;
    .subject-item-title {
        font-weight: 600;
        font-size: 1.4rem;
        color: #3B3B42;
    }
    .subject-item-info {
        font-size: 1.2rem;
        color: #979797;
    }
`

const SubjectListItem = ({ subjectTitle, subjectTerm, numberOfTopics }) => {
    return (
        <Item>
            <ImageTextContainer>
                <ImageContainer>
                    <MdAssessment />
                </ImageContainer>
                <TextContainer>
                    <p className="subject-item-title">{subjectTitle}</p>
                    <p className="subject-item-info">{subjectTerm} Term | {numberOfTopics} Topics</p>
                </TextContainer>
            </ImageTextContainer>
            <Link to='/student/subjects/view'>
                <Button style={{ width: '6rem', height: '2.5rem', fontSize: '1rem' }} variant="secondary">VIEW</Button>
            </Link>
        </Item>
    )
}

export default SubjectListItem
